import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';

import styles from './ToggleSwitch.module.css';

export type ToggleSwitchProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  onText?: string;
  offText?: string;
  disabled?: boolean;
  loading?: boolean;
  showLoadingIcon?: boolean;
  width?: number;
  height?: number;
  className?: string;
};

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked,
  onChange,
  onText = '모델 서빙 ON',
  offText = '모델 서빙 OFF',
  disabled = false,
  loading = false,
  showLoadingIcon = true,
  width = 150,
  height = 32,
  className,
}) => {
  const handleClick = () => {
    if (disabled || loading) return;
    onChange(!checked);
  };

  const toggleClassName = [
    styles.toggle,
    checked ? styles.checked : styles.unchecked,
    loading && styles.loading,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      className={toggleClassName}
      onClick={handleClick}
      disabled={disabled || loading}
      style={{ width: `${width}px`, height: `${height}px`, minHeight: `${height}px` }}>
      <span className={styles.thumb}>
        {loading && showLoadingIcon && <LoadingOutlined className={styles.thumbLoadingIcon} spin />}
      </span>
      <span className={styles.text}>{checked ? onText : offText}</span>
    </button>
  );
};
